/**
 * @flow
 * @relayHash fb59d4aa0ca6dd14f2855e52c7ca72fa
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type AddCartItemMutationVariables = {|
  input: {
    action: "ADD" | "EDIT" | "REMOVE" | "REORDER";
    description?: ?string;
    endPortfolioId?: ?string;
    itemsIds?: ?$ReadOnlyArray<?string>;
    name?: ?string;
    note?: ?string;
    portfolioIds?: ?$ReadOnlyArray<?string>;
    portfoliosType: "CART" | "PROCUREMENT" | "HEART" | "FOLDER" | "PROJECT";
    privacyLevel?: ?"PRIVATE" | "PUBLIC" | "SHAREABLE";
    startPortfolioId?: ?string;
    targetPortfolioId?: ?string;
    userId: string;
    clientMutationId?: ?string;
  };
|};

export type AddCartItemMutationResponse = {|
  +modifyPortfolios: ?{|
    +portfolios: ?$ReadOnlyArray<?{|
      +items: ?{|
        +totalResults: ?number;
      |};
    |}>;
  |};
|};
*/


/*
mutation AddCartItemMutation(
  $input: ModifyPortfoliosInput!
) {
  modifyPortfolios(input: $input) {
    portfolios {
      items {
        totalResults
      }
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ModifyPortfoliosInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddCartItemMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ModifyPortfoliosInput!"
          }
        ],
        "concreteType": "ModifyPortfoliosPayload",
        "name": "modifyPortfolios",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "PortfolioV2",
            "name": "portfolios",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "PortfolioItemsConnection",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "AddCartItemMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ModifyPortfoliosInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "AddCartItemMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ModifyPortfoliosInput!"
          }
        ],
        "concreteType": "ModifyPortfoliosPayload",
        "name": "modifyPortfolios",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "PortfolioV2",
            "name": "portfolios",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "PortfolioItemsConnection",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation AddCartItemMutation(\n  $input: ModifyPortfoliosInput!\n) {\n  modifyPortfolios(input: $input) {\n    portfolios {\n      items {\n        totalResults\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/components/CartNav/__generated__/AddCartItemMutation.graphql.js